import EventBus from '@/event-bus';

import displayAdaptable from '@/mixins/displayAdaptable';

export default {
  mixins: [displayAdaptable],

  watch: {
    value() {
      this.mobileDialogOpen(this.value);
    },
  },

  methods: {
    mobileDialogOpen(open) {
      if (this.isMobile()) {
        if (open) {
          EventBus.$emit('mobile-dialog-open');
        } else {
          EventBus.$emit('mobile-dialog-close');
        }
      }
    },
  },

  mounted() {
    EventBus.$on('mobile-dialog-close-all', () => {
      if (this.closeOperation) {
        this.closeOperation();
      } else {
        this.$emit('close');
      }
    });
  },

  beforeDestroy() {
    EventBus.$off('mobile-dialog-close-all');
  },
};
